export default {
  computed: {
    input() {
      return this.inputCase.input;
    },
    output() {
      return this.caseOutputs.PRODUCTION_COST;
    },
    simulationYearArray() {
      const size = this.inputCase.settings.year_end - this.inputCase.settings.year_start;
      const yearArray = Array(1).fill(this.inputCase.settings.year_start);
      for (let i = 0; i < size; i += 1) {
        yearArray[i + 1] = yearArray[i] + 1;
      }
      return yearArray;
    },
    renewableEnergyCourtailment() {
      return Object.values(this.output.generators).reduce((acc, obj) => {
        if (obj.type === "RENEWABLE") {
          acc[obj.source] = Object.values(obj.energy_curtailment);
        }
        return acc;
      }, {});
    },
    // Generation By Fuel Type
    generationByFuelType() {
      if (this.output.generators[0].annual_generation) {
        return Object.values(this.output.generators).reduce((acc, obj) => {
          const key = obj.source;
          if (!acc[key]) {
            acc[key] = Object.values(obj.annual_generation).map((el) => el / 1000);
          } else {
            acc[key] = Object.values(acc[key]).map(
              (generation, index) =>
                generation + Object.values(obj.annual_generation).map((el) => el / 1000)[index]
            );
          }
          return acc;
        }, {});
      }
      return Object.values(this.output.fuel_types).reduce((acc, obj) => {
        const key = obj.type;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key] = Object.values(obj.generation);
        return acc;
      }, {});
    },

    // Storage Installed Capacity
    storageInstalled() {
      return Object.values(this.output.storage).reduce((acc, obj) => {
        const key = obj.name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key] = Object.values(obj.installed_capacity);
        return acc;
      }, {});
    },

    // Storage Energy Revenue
    storageEnergyRevenue() {
      return Object.values(this.output.storage).reduce((acc, obj) => {
        const key = obj.name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key] = Object.values(obj.energy_revenue);
        return acc;
      }, {});
    },
    // Storage Quick Look
    storageQuickLook() {
      const storageSum = Object.values(this.storageInstalled).reduce((acc, storage) => {
        storage.forEach((acc2, index) => {
          acc[index] = (acc[index] || 0) + acc2;
        });
        return acc;
      }, []);
      return storageSum;
    },
    horizon() {
      return Object.keys(this.output.co2_emissions).length;
    },

    // Created Date
    date() {
      return this.inputCase.created.substring(0, this.inputCase.created.indexOf("T"));
    },

    // Created Time
    time() {
      return this.inputCase.created.substring(
        this.inputCase.created.indexOf("T") + 1,
        this.inputCase.created.indexOf(".")
      );
    },
  },

  methods: {
    getOutput(name, inout) {
      if (typeof name === "string") {
        return inout[name] || [];
      }
      if (typeof name === "function") {
        return name(inout);
      }
      throw Error(`Invalid output key ${name}`);
    },
    formatString(character) {
      // eslint-disable-next-line no-param-reassign
      character = character.replace(/_/g, " ");
      const separateWord = character.toLowerCase().split(" ");
      separateWord.forEach((el, index) => {
        separateWord[index] =
          separateWord[index].charAt(0).toUpperCase() + separateWord[index].substring(1);
      });
      return separateWord.join(" ");
    },
  },
};
